var parent = require('../../es/object/get-own-property-descriptor');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/object/get-own-property-descriptor.js
// module id = 1127
// module chunks = 0